import $ from 'jquery';
import t from './util/i18n';

class UpperLimitManager {
  static alert = (target) => {
    if (UpperLimitManager.isUpperLimitOver(target)) {
      window.alert(t('checkbox_synchronizer.alert', { count: UpperLimitManager.getUpperLimit(target) }));// eslint-disable-line no-alert
      $(target).prop('checked', false);
    }
  }

  static getUpperLimit = (target) => {
    const $form = $(target).closest('form');

    return $form.data('upper-limit') || 70;
  }

  static isUpperLimitOver = (target) => {
    const $form = $(target).closest('form');
    const upperLimit = UpperLimitManager.getUpperLimit(target);

    return $form.find('input:checkbox:checked').length > upperLimit;
  }
}

class CheckboxSynchronizer {
  constructor({ wrapper, type }) {
    this.$wrapper = $(wrapper);
    this.type = type;
    this.$checkboxes = this.$wrapper.find('input:checkbox');
  }

  static generateSelectorByType = ($target, $form, type) => {
    switch (type) {
      case 'data':
        return $form.find(`input:checkbox[data-checkbox-synchronizer-id="${ $target.data('checkbox-synchronizer-id') }"]`);
      case 'id':
        return $form.find(`input:checkbox[id="${ $target.attr('id') }"]`);
      default:
        return $form.find(`input:checkbox[value="${ $target.val() }"]`);
    }
  }

  static sync = (target, { type = 'value', form }) => {
    const $target = $(target);
    const $form = $(form).length > 0 ? $(form) : $target.closest('form');
    const $synchronizationCheckboxes = CheckboxSynchronizer.generateSelectorByType($target, $form, type);

    if (!$synchronizationCheckboxes.length) {
      return [];
    }

    if ($target.prop('checked')) {
      $synchronizationCheckboxes.prop('checked', true);
    } else {
      $synchronizationCheckboxes.prop('checked', false);
    }

    return $synchronizationCheckboxes;
  }

  static syncLazyLoaded = (target, { type = 'value', form }) => {
    const $target = $(target);
    const $form = $(form).length > 0 ? $(form) : $target.closest('form');
    const $synchronizationCheckboxes = CheckboxSynchronizer.generateSelectorByType($target, $form, type);
    const isChecked = $synchronizationCheckboxes.not($target).eq(0).prop('checked');

    $target.prop('checked', isChecked);
  }
}

export {
  UpperLimitManager,
  CheckboxSynchronizer,
};
